import { createAuthClient } from 'better-auth/react';
import { adminClient } from 'better-auth/client/plugins';
import { ac, producer, org_admin, vendor, platform_admin } from './permissions';
import { nextCookies } from 'better-auth/next-js';

export const authClient = createAuthClient({
  plugins: [
    adminClient({
      ac,
      roles: {
        producer,
        org_admin,
        vendor,
        platform_admin,
      },
    }),
    nextCookies(),
  ],
});
